import { useState, useEffect, useCallback, useRef } from 'react';
import { useTheme } from '../../context/theme';
import { api } from '../../utils/api';
import { renderIcon } from '../../utils/icons';

export function NotificationBell({ onNav }) {
  const { theme, isDark } = useTheme();
  const [open, sOpen] = useState(false);
  const [notifs, sNotifs] = useState([]);
  const [unread, sUnread] = useState(0);
  const ref = useRef(null);

  const load = useCallback(async () => {
    try {
      const d = await api.get('/api/notifications');
      sNotifs(d.notifications || []);
      sUnread((d.notifications || []).filter(n => !n.read).length);
    } catch {}
  }, []);

  useEffect(() => { load(); const i = setInterval(load, 30000); return () => clearInterval(i); }, [load]);
  useEffect(() => {
    const h = e => { if (ref.current && !ref.current.contains(e.target)) sOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const markRead = async (id) => { try { await api.put(`/api/notifications/${id}/read`, {}); load(); } catch {} };
  const markAllRead = async () => { try { await api.put('/api/notifications/read-all', {}); load(); } catch {} };

  const timeAgo = (d) => {
    const s = Math.floor((Date.now() - new Date(d)) / 1000);
    if (s < 60) return s + 's ago';
    if (s < 3600) return Math.floor(s / 60) + 'm ago';
    if (s < 86400) return Math.floor(s / 3600) + 'h ago';
    return Math.floor(s / 86400) + 'd ago';
  };

  const typeIcon = { assignment: 'pin', document: 'file', mention: '@', note: 'file-text', site: 'hard-hat', pipeline: 'search' };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button onClick={() => sOpen(!open)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: 'rgba(255,255,255,0.58)', position: 'relative', padding: '4px 8px' }} title="Notifications">
        {renderIcon('bell', 16)}
        {unread > 0 && (
          <span style={{ position: 'absolute', top: -2, right: 0, background: '#ef4444', color: '#fff', fontSize: 10, fontWeight: 800, borderRadius: 10, minWidth: 18, height: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 4px' }}>
            {unread > 99 ? '99+' : unread}
          </span>
        )}
      </button>
      {open && (
        <div style={{ position: 'absolute', right: 0, top: '100%', marginTop: 8, width: 360, maxHeight: 420, background: theme.bgCard, border: `1px solid ${theme.border}`, borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.4)', zIndex: 100, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: '12px 16px', borderBottom: `1px solid ${theme.border}`, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: 15, fontWeight: 700, color: theme.text }}>Notifications</span>
            {unread > 0 && <button onClick={markAllRead} style={{ background: 'none', border: 'none', color: theme.text, cursor: 'pointer', fontSize: 12, fontWeight: 600 }}>Mark all read</button>}
          </div>
          <div style={{ overflow: 'auto', flex: 1 }}>
            {notifs.length === 0 && (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '24px 16px', textAlign: 'center' }}>
                <div style={{ fontSize: 32, marginBottom: 8, opacity: 0.7 }}>{renderIcon('bell', 32)}</div>
                <div style={{ fontSize: 13, color: theme.textSecondary }}>No notifications yet</div>
              </div>
            )}
            {notifs.map(n => (
              <div
                key={n.id}
                onClick={() => { markRead(n.id); if (n.link && onNav) { if (n.link.includes('pipeline')) onNav('pipeline'); else if (n.link.includes('sites')) onNav('sites'); else onNav('dashboard'); } sOpen(false); }}
                style={{ padding: '10px 16px', borderBottom: '1px solid rgba(255,255,255,0.06)', cursor: 'pointer', background: n.read ? 'transparent' : 'rgba(255,255,255,0.03)', transition: 'background .2s' }}
              >
                <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                  <span style={{ fontSize: 16, flexShrink: 0 }}>{renderIcon(typeIcon[n.type] || 'bell', 14)}</span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 13, fontWeight: n.read ? 400 : 700, color: n.read ? theme.textSecondary : theme.text, lineHeight: 1.3 }}>{n.title}</div>
                    {n.message && <div style={{ fontSize: 12, color: theme.textMuted, marginTop: 2, lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{n.message}</div>}
                  </div>
                  <span style={{ fontSize: 11, color: theme.textMuted, flexShrink: 0, whiteSpace: 'nowrap' }}>{timeAgo(n.created_at)}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
